import CreateInvestmentError from './CreateInvestmentError';
class PropertyHasNoAvailableBricks extends CreateInvestmentError {
    constructor(options) {
        super('Target Property has no available bricks', options);
    }
}
export default PropertyHasNoAvailableBricks;
